import { Box, Grid, Typography, IconButton } from "@mui/material";
import "./calendar.css";
import MenuIcon from "@mui/icons-material/Menu";
import RefreshIcon from "@mui/icons-material/Refresh";
import React, { useContext, useEffect, useState } from "react";
import ApiService from "../../functions/apiService";
import CalendarPicker from "../../components/Calendar/CalendarPicker";
import { convertCalendarObjectToArray, swapKeysAndValues } from "../../utils/helperFunctions";
import CalendarLoader from "../../components/Calendar/CalendarLoader";
import Notes from "../../components/Calendar/Notes";
import { useNavigate, useSearchParams } from "react-router-dom";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import moment from "moment/moment";
import AuthContext from "../../context/AuthContext";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";

const CALENDAR_REFRESH_GATE_MINUTES = 5;

const Calendar = () => {
  let navigate = useNavigate();
  const [calendar, setCalendar] = useState({});
  const popup = localStorage.getItem('haseenPopup')
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noteLoading, setNoteLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isNotesOpen, setIsNotesOpen] = useState(1);
  const [payrollStatus, setPayrollStatus] = useState('');
  const routeDate = searchParams.get('date');
  const { pages, permission  , v3Data} = useContext(AuthContext);
  const [callbackPopup , setCallBackPopup] = useState(false);
  const [lastSyncedAt, setLastSyncedAt] = useState(null);
  const [, forceSyncTextTick] = useState(0);

  const getCalendar = async (isRefresh = false) => {
    setLoading(true);
    const params = isRefresh ? { refresh: 1 } : {};
    const response = await ApiService.get(`/calendar/${selectedDate.getFullYear()}/${selectedDate.getMonth() + 1}`, params, 'calendar');
    setCalendar(response.data);
    if (response.data?.last_synch_at) {
      setLastSyncedAt(new Date(response.data.last_synch_at));
    }
    setLoading(false);
  };

  const handleRefreshCalendar = () => {
    getCalendar(true);
  };

  const getNotes = () => {
    setNoteLoading(true)
    let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    ApiService.get(`/notes/${selectedDate.getFullYear()}/${month}`, {}, 'notes').then(({ data }) => {
      setNoteLoading(false)
      setNotes(data.data);
    }).catch(() => setNoteLoading(false));
  };

  // useEffect(() => {
  //   if (routeDate && routeDate != selectedDate) {
  //     setSelectedDate(new Date(routeDate))
  //   }
  // }, [])
  useEffect(() => {
    setSearchParams({ date: moment(selectedDate).format('YYYY-MM') });
    getCalendar();
    getNotes();
    if(localStorage.getItem('V3_LOCK_PAYROLL_FEATURE') === 'true'){
        PayrollStatus();
    }
  }, [selectedDate]);

  const calendarArr = convertCalendarObjectToArray(calendar?.calendar || {});
  const events = swapKeysAndValues(calendar?.events || {});
  const garciaCycle = calendar?.garciaCycle || null;

  let RedirectToSchedual = (date) => {
    navigate('/firehouse/schedule?date=' + date)
  }

  const recalculateSeniority = () => {
      ApiService.get('/checkForRecalculateSeniorityRequest')
        .catch((e) => {
          console.error(e || 'error')
        })
  }

  const PayrollStatus = () => {
		setLoading(true);
		ApiService.post('/payrolllock/get', {
			month: selectedDate.getMonth() + 1,
			year: selectedDate.getFullYear()
		}).then((data) => {
      setPayrollStatus(data?.data?.status)
			setLoading(false);
		}).catch((e) => {
			setLoading(false);
      console.error(e)
		});
	};

  const LockPayroll = () => {
		setLoading(true);
		ApiService.post('/payrolllock/add', {
			month: selectedDate.getMonth() + 1,
			year: selectedDate.getFullYear()
		}).then((data) => {
      toast.success(data?.message)
      PayrollStatus()
			setLoading(false);
		}).catch((e) => {
			setLoading(false);
			toast.error(e?.data?.message)
		});
	};

  useEffect(()=>{
    if(pages && pages.includes('V3_RECALCULATE_SENIORITY')){
      recalculateSeniority();
    }
  } , [])

  const loadCallBackData = () => {
    setLoading(true);
    ApiService.get("/callback-employee-popup")
      .then(({ data }) => {
        if(data?.Request && data?.Request == true && popup === 'true'){
          setCallBackPopup(true)
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(()=>{
    loadCallBackData()
  } , [])

  useEffect(() => {
    const interval = setInterval(() => forceSyncTextTick((t) => t + 1), 30000);
    return () => clearInterval(interval);
  }, []);

  const minutesSinceSync = lastSyncedAt ? Math.floor((Date.now() - lastSyncedAt.getTime()) / 60000) : null;
  const lastSyncedText = minutesSinceSync === null
    ? ''
    : minutesSinceSync <= 0
      ? 'Last synced a few seconds ago'
      : `Last synced ${minutesSinceSync} minutes ago`;
  const showRefreshIcon = minutesSinceSync !== null && minutesSinceSync >= CALENDAR_REFRESH_GATE_MINUTES;

  return (
    <>
      {/* <ManagementHeaderNav /> */}
      <div style={{ overflow: 'hidden', backgroundColor: "#fff", marginTop: '20px' }}>
        <div
          style={{
            marginLeft: !pages.includes('CALENDER_DISPLAY_NOTES') ? '36%' : isNotesOpen == 1 ? '24%' : '34%',
            transition: 'margin-left 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: "space-between"
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CalendarPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
            {v3Data?.V3_CALENDAR_STORAGE && lastSyncedAt &&
              <Box display="flex" alignItems="center" gap="4px" marginTop="10px" marginLeft="15px">
                <Typography variant="body2" style={{ color: '#BF1D2D', whiteSpace: 'nowrap' }}>
                  {lastSyncedText}
                </Typography>
                {showRefreshIcon &&
                  <IconButton size="small" onClick={handleRefreshCalendar}>
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                }
              </Box>
            }
          </div>
          {v3Data?.V3_ALLOW_DISPLAY_GARCIA_SCHEDULE &&
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '25px' }}>
              {garciaCycle && (
                <div className="garcia-cycle-pills">
                  <span className="garcia-cycle-pill garcia-cycle-start">
                    GC Start: {moment(garciaCycle.start_date).format('MMM D')}
                  </span>
                  <span className="garcia-cycle-pill garcia-cycle-end">
                    GC End: {moment(garciaCycle.end_date).format('MMM D')}
                  </span>
                </div>
              )}
              {permission.includes("Schedule_Auth") && (localStorage.getItem('V3_LOCK_PAYROLL_FEATURE') === 'true') && (payrollStatus !== "donotshow") &&
                <ButtonTheme
                  color='primary'
                  style={{
                    marginTop: '8px',
                  }}
                  // disabled= {payrollStatus === "locked"}
                  onClick={() => { LockPayroll() }}
                >
                  {payrollStatus === "locked" ? "Unlock Payroll" : "Lock Payroll"}
                </ButtonTheme>}
            </div>
          }
        </div>

        <Grid className="m-0" container spacing={2} columns={{ xs: 5, lg: 10 }}>
          <Grid item xs={5}
            lg={!pages.includes('CALENDER_DISPLAY_NOTES') ? 12 : isNotesOpen == 1 ? 7 : 9}
            style={{ paddingRight: pages.includes('CALENDER_DISPLAY_NOTES') ? '10px' : '30px', transition: 'all 0.2s ease-in-out' }}>
            <Box backgroundColor="#fff">
              <Box display="flex" flexWrap="wrap" borderTop="2px solid #cac9c9" borderLeft="2px solid #cac9c9" borderRight="2px solid #cac9c9">
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>SUN</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>MON</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>TUE</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>WED</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>THUR</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>FRI</Typography>
                </div>
                <div className="calendar-header-item">
                  <Typography fontWeight="600" style={{ marginLeft: '35%' }}>SAT</Typography>
                </div>
              </Box>
              {loading ? (
                <CalendarLoader />
              ) : (
                <Box display="flex" flexWrap="wrap" borderTop='2px solid #cac9c9' borderRight='2px solid #cac9c9'>
                  {calendarArr?.map((item, index) => {
                    return (
                      <Box key={index} onClick={() => RedirectToSchedual(item.date)}
                        className="calendar-header-item position-relative" borderBottom="2px solid #cac9c9" borderLeft="2px solid #cac9c9"
                        style={{ cursor: 'pointer', minHeight: '126px', backgroundColor: moment(item.date).isSame(new Date, 'day') ? "rgba(191, 29, 45, 0.2)" : 'transparent' }}>
                        <Typography fontSize="24px" variant="h6" marginBottom="20px">
                          {Number(item.date[8]) > 0 && item.date[8]}
                          {item.date[9]}
                        </Typography>
                        {events[item.date] ? (
                          <Typography fontSize="14px" variant="span" className="shift-count">
                            {events[item.date]}
                          </Typography>
                        ) : (
                          <Typography fontSize="14px" variant="span"></Typography>
                        )}
                        {calendar && calendar.overtime && calendar.overtime.filter((i) => i.shiftDate == item.date).length > 0 ?
                          calendar.overtime.filter((i) => i.shiftDate == item.date).map(overtime => (
                            <Typography fontSize="14px" style={{ color: overtime.color }} >
                              {overtime?.shiftText ? overtime?.shiftText : overtime.count + ' ' + overtime.statusText}  &nbsp;   &nbsp;
                            </Typography>
                          ))
                          :
                          <br />
                        }
                        {calendar && calendar.overtimeRequset && calendar.overtimeRequset.filter((i) => i.shiftDate == item.date).length > 0 ?
                          calendar.overtimeRequset.filter((i) => i.shiftDate == item.date).map(overtime => (
                            <Typography fontSize="14px" style={{
                              color: overtime.color
                              //  color: 'purple'
                            }} >
                              {overtime.count + ' Requests'}  &nbsp;   &nbsp;
                            </Typography>
                          ))
                          :
                          <br />
                        }
                        <br />
                        <div className="position-absolute bottom-0  mb-1">
                          {item?.groupName?.map((group, i) => {
                            return <Typography fontSize="14px" color={item.groupColor[i]} variant="span" className="shift-count ">
                              {group}
                            </Typography>
                          })}
                        </div>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          </Grid>
          {pages.includes('CALENDER_DISPLAY_NOTES') && (
            <Grid
              item
              xs={5}
              lg={isNotesOpen == 1 ? 3 : 1}
              className="p-1"
              style={{ marginTop: '12px', transition: 'all 0.2s ease-in-out' }}
            >
              <Notes notes={notes} loading={noteLoading} setIsNotesOpen={setIsNotesOpen} isNotesOpen={isNotesOpen} />
            </Grid>
          )}
        </Grid>
      </div>
      <Modal show={callbackPopup} onHide={() => 
      {
        setCallBackPopup(false)
        localStorage.setItem("haseenPopup" , "false");
      }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Callback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Kindly review your Callback requests.
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => {
                navigate('/firehouse/accept-shifts')
                localStorage.setItem("haseenPopup" , "false");
              }}>
                Redirect
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Calendar;
